import { controllers } from "../../Controllers/Controllers";
import { UPDATE } from "../../DataTypes/UPDATE";
import AuthModal from "../../Views/AImade/AuthModalView";
import { AuthModalWrapper } from "../../Views/Modals/AuthModalWrapper";
import { LangItem } from "./LangItem";
import { UpdateComponent } from "./UpdateComponent";

type authItemProps = {
    children: any;
    isLogined: boolean;
    enableAuth?: boolean;
    notAuthorized?: any;
    isChat?: boolean;
}

class AuthChecker extends UpdateComponent {
    props: authItemProps;
    constructor(props:authItemProps){
        super(props)
        this.type = UPDATE.USERINFO
        this.props = props
    }

    render(){
        const { children, isLogined, enableAuth, notAuthorized, isChat} = this.props
        const { userInfo, isLogin, tokenForChat} = controllers().auth
        if(isChat === true && tokenForChat!=null){
            return children
        }
        if(isLogin && !userInfo){
            return null
        }
        return isLogin == isLogined  ? this.props.children : 
        (enableAuth ? <AuthModal hideModal={()=>{}}/> : notAuthorized)
        // return isLogin == isLogined  ? this.props.children : null
    }
}

export { AuthChecker }